module.exports = __webpack_public_path__ + "static/media/reveues-icon.e633f9d3.svg";